import { Auth } from 'aws-amplify';
import { toast } from 'react-toastify';

const API_URL = process.env.REACT_APP_CONTRACTS_MANAGEMENT_API_URL;
const API_KEY = process.env.REACT_APP_API_KEY;

export const useFileDownload = () => {
    const handleDownload = async (creditOperationId: string, fileName: string) => {
        try {
            const token = await Auth.currentSession().then((user) => user.getIdToken().getJwtToken());
            const response = await fetch(`${API_URL}/download/${creditOperationId}/${fileName}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'x-api-key': API_KEY || ''
                }
            });
            if (response.ok) {
                const data = await response.json();
                const a = document.createElement('a');
                a.href = data.url;
                a.download = data.filename || fileName;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            } else {
                toast.error('Erro ao baixar arquivo');
            }
        } catch (error) {
            toast.error('Erro ao conectar com o servidor');
        }
    };

    return { handleDownload };
};
